import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { DynamicFormControl } from '../../models/dynamic-form-control.model';
import { FilterService } from 'src/app/shared/filtering';
import { Subscription } from 'rxjs';
import { MatFormField, MatLabel, MatHint } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { DYNAMIC_ERROR_STATE_MATCHER } from '../../services/dynamic-control-error-state-matcher';

@Component({
  selector: 'lib-select-control',
  imports: [
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    ReactiveFormsModule,
    MatHint,
  ],
  templateUrl: './select-control.component.html',
  styleUrl: './select-control.component.scss',
})
export class SelectControlComponent {
  @Input() control: DynamicFormControl;
  @Input() isReadonly: boolean;
  inputControl: FormControl;
  errorStateMatcher = DYNAMIC_ERROR_STATE_MATCHER;

  private _subscriptions: Subscription[] = [];

  /**
   * Drives the Material required-asterisk explicitly instead of relying on
   * Material's implicit validator detection, which fails to render the asterisk
   * for controls that stay empty (e.g. a disabled, pre-populated field) because
   * no `stateChanges` event is emitted to refresh the form field.
   */
  get isRequired(): boolean {
    return (
      this.control?.customOptions?.isRequired ||
      this.inputControl?.hasValidator(Validators.required) ||
      false
    );
  }

  constructor(private filterService: FilterService) {}

  ngOnInit() {
    this.inputControl = this.control.formControls[0].formControl;

    let sub = this.filterService.activeFilterRemoved$.subscribe({
      next: (i) => {
        if (i.propertyBinding === this.control.propertyBinding) {
          this.control.formControls[0].formControl.setValue(null);
        }
      },
      error: (e) => console.log(e),
    });

    this._subscriptions.push(sub);
  }

  ngOnDestroy() {
    this._subscriptions.forEach((i) => i.unsubscribe());
  }
}
